/**
 * token 操作封装
 */
import { TOKEN_STORE_NAME } from '@/config/setting';

let memoryToken = '';

function getWebStorage(name) {
  try {
    if (name === 'localStorage' && typeof localStorage !== 'undefined') {
      return localStorage;
    }
    if (name === 'sessionStorage' && typeof sessionStorage !== 'undefined') {
      return sessionStorage;
    }
  } catch (e) {
    return null;
  }
  return null;
}

/**
 * 获取缓存的 token
 */
export function getToken() {
  if (memoryToken) {
    return memoryToken;
  }
  const local = getWebStorage('localStorage');
  const session = getWebStorage('sessionStorage');
  const token = local && local.getItem(TOKEN_STORE_NAME);
  if (!token) {
    return (session && session.getItem(TOKEN_STORE_NAME)) || memoryToken;
  }
  return token;
}

/**
 * 缓存 token
 * @param token token
 * @param remember 是否永久存储
 */
export function setToken(token, remember) {
  removeToken();
  if (token) {
    memoryToken = token;
    if (remember) {
      const local = getWebStorage('localStorage');
      if (local) {
        local.setItem(TOKEN_STORE_NAME, token);
      }
    } else {
      const session = getWebStorage('sessionStorage');
      if (session) {
        session.setItem(TOKEN_STORE_NAME, token);
      }
    }
  }
}

/**
 * 移除 token
 */
export function removeToken() {
  memoryToken = '';
  const local = getWebStorage('localStorage');
  const session = getWebStorage('sessionStorage');
  if (local) {
    local.removeItem(TOKEN_STORE_NAME);
  }
  if (session) {
    session.removeItem(TOKEN_STORE_NAME);
  }
}
